/**
 * Utility to extract keys from an object while preserving type information.
 *
 * @param object Object to extract keys from.
 */
export function keys<T extends object>(object: T) {
  return Object.keys(object) as (keyof T)[];
}
